<template>
  <div
    v-if="totalPages > 1"
    class="pagination__wrapper d-flex flex-column justify-center"
    ref="pagination_wrapper"
  >
    <div v-if="show_btn === true" class="d-flex align-center justify-center mb-9">
      <v-btn
        color="lightGreen"
        class="show-more_btn d-flex align-center justify-center active-color"
        @click="showMore()"
        :disabled="page == totalPages"
      >
        <!-- @click="$emit('show_more')" -->
        <i class="icon-refresh mr-3"></i> {{$t('Показать ещё')}}
      </v-btn>
    </div>
    <div class="d-flex justify-center">
      <!-- Назад -->
      <span
        @click="prevPage()"
        :class="{disabled: page === 1}"
        class="page__number mr-6 pagination__arrow arrow__prev"
      >
        <i class="icon-arrow-left"></i> Назад
      </span>

      <!-- 1 страница -->
      <span
        @click="changePage(1)"
        class="page__number pNormal"
        :class="{'page__number--active': page === 1}"
      >1</span>

      <!-- Точки -->
      <span v-if="page>4" class="dots pNormal">...</span>

      <!-- Центральный блок -->
      <div class="d-flex center_block-page">
        <span
          v-show="checkpages(item)"
          @click="changePage(item)"
          class="page__number pNormal"
          :class="{'page__number--active': page === item}"
          v-for="(item, index) in totalPages"
          :key="index"
        >{{ item }}</span>
      </div>

      <!-- Точки -->
      <span v-if="page<totalPages-2" class="dots pNormal">...</span>

      <!-- Последняя страница -->
      <span
        v-if="totalPages !== 1"
        @click="changePage(totalPages)"
        class="page__number pNormal"
        :class="{'page__number--active': page === totalPages}"
      >{{ totalPages }}</span>

      <!-- Вперёд -->
      <span
        @click="nextPage()"
        :class="{disabled: page === totalPages}"
        class="page__number ml-6 pagination__arrow arrow__next"
      >
        Вперёд
        <i class="icon-arrow-left"></i>
      </span>
    </div>
  </div>
</template>

<script>
/**
 * arr ( Array ) - Массив, который привязан к пагинации. Требуется для вычисления количества страниц
 * currentPage ( Number ) - начальная страница. Указывает, с какой страницы отображать список
 * length ( Number ) - длина отображаемого массива (кол-во элементов на странице)
 * multi ( Boolean ) - требуется, если пагинации на странице более 1. Функция включена по дефолту. Вариант с vuex удалил. Не актуален.
 * При использовании multi в родительском компоненте обязательно принять объект (@params="название_метода") со значениями length и currentPage.
 * ПРИМЕР:
 * название_метода(data) {
      this.params = data //где this.params - заранее объявленный объект в data()
    }
 *
 * (НЕ ИСПОЛЬЗУЕТСЯ, ОТКЛЮЧЕНО) Если пагинация на странице одна, пользуемся Vuex. В родительском компоненте
 * получаем объект в поле computed() при помощи комманды return this.$store.getters.params;
 * и далее используем в функции.
 *
 * Объект params: {
    length: '',
    currentPage: ''
  }
 * Ключи объекта совпадают с названиями пропов в поле props()
 *
 * Пример фильтрации списка:
 * usersSort() {
    return this.users.filter((row, index) => {
      let start = (this.params.currentPage - 1) * this.params.length
      let end = this.params.currentPage * this.params.length
      if (index >= start && index < end) return true
    })
  },
 */
export default {
  props: {
    arr: {
      type: Array,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    length: {
      type: Number,
      required: true
    },
    multi: {
      type: Boolean,
      default: true
    },
    pageTotal: {
      type: Number,
      default: null
    },
    show_btn: Boolean,
    // Класс общего родителя. Нужен, если пагинация находится в модалке. Класс нужно указать всей модалки.
    parentClass: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      page: "",
      currentLength: null,
      changeLength: true,
      curPage: null
    };
  },
  created() {
    this.getPage;
    this.getCurrentLength;
    this.$emit("params", {
      currentPage: this.currentPage,
      length: this.currentLength
    });
    // }
  },
  watch: {
    arr() {
      if (this.pageTotal === null) {
        this.changeLength = true;
        this.$emit("params", {
          currentPage: 1,
          length: this.currentLength
        });
        this.page = 1;
      }
    }
  },
  computed: {
    getPage() {
      this.page = this.currentPage;
    },
    getCurrentLength() {
      this.currentLength = this.length;
    },
    totalPages() {
      let numPages;
      if (!this.pageTotal) {
        if (this.changeLength) {
          numPages = Math.ceil(this.arr.length / this.currentLength);
        } else numPages = Math.ceil(this.arr.length / this.length);
      } else numPages = this.pageTotal

      return numPages;
    }
  },
  methods: {
    /**
     * При клике на кнопку вызывается эта функция, которая скроллит страницу до верха контейнера, в котором находятся элементы.
     */
    scrollPageToTopParent() {
      let wrapper = this.parentClass === "" ? window : document.querySelector(`.${this.parentClass}`), //элемент, который нужно прокручивать
        parentPagination = this.$refs.pagination_wrapper.parentElement, // родитель, в котором находится блок пагинации
        topCoordParentPagination =
          parentPagination.getBoundingClientRect().top + window.pageYOffset // вычисляем координаты родителя;

          // Прокручиваем окошко до верхней координаты. Так же вычитаем 64px - высота шапки.
          wrapper.scrollTo({
            top: topCoordParentPagination - 64,
            behavior: "smooth"
          });
    },
    /**
     * Подсвечивает активную страницу, а так же считает сколько кнопок будет рядом с активной страницей
     */
    checkpages(item) {
      let amoountBlockOnRow = document.body.clientWidth >= 575 ? 3 : 2;
      /*
       * функция получает каждую страницу и отбирает по условиям если true то елемент попадает на страницу
       * первая страница неотображаемая так как выведена статично как и последняя
       * нужно вывести 5 элементов от активной страницы
       */
      if (item === 1) {
        return false;
      } // для первой страницы
      if (item === this.totalPages) {
        return false;
      } // для последней страницы

      let start = this.page - amoountBlockOnRow; // старт = текущая страница минус реинж
      let end;

      if (this.page === this.totalPages) {
        start = this.page - amoountBlockOnRow;
      }
      // if (this.page === this.totalPages - 1) { //не работает
      //   start = this.page - 6;
      // }
      // if (this.page === this.totalPages - 2) { //не работает
      //   start = this.page - 5
      // }
      // if (this.page === this.totalpages - 3) {
      //   start = this.page - 4;
      // }
      // if (this.page === this.totalpages - 4) {
      //   start = this.page - 3;
      // }

      if (item < 8) {
        // хз почему 8
        end = this.page + amoountBlockOnRow; // цифра - количество страниц в начале включая первую
      } else {
        end = this.page + amoountBlockOnRow; // цифра - количество страниц от активной вправо включая активную
      }
      if (start < item && end > item) {
        //3 < 8 и 13 > 8
        // console.log(item+'second');
        return true;
      }
    },
    /**
     * Функция листает страницы.
     * @param {Number} item - номер страницы, на которую нужно перейти
     * @param {Number} term - число, при котором страница не перелистнётся. Нужно чтобы this.page не уходил в минус при клике на кноки "Вперед" и "Назад".
     */
    changePage(item, term = item) {
      this.scrollPageToTopParent();
      if (this.page !== term) {
        this.page = item;
        this.currentLength = this.length;
        this.$emit("params", {
          currentPage: this.page,
          length: this.currentLength
        });
      }
    },
    /**
     * Перелистывает на предыдущую страницу
     */
    prevPage() {
      this.changePage(this.page - 1, 1);
    },
    /**
     * Перелистывает на следующую страницу
     */
    nextPage() {
      this.changePage(this.page + 1, this.totalPages);
    },
    /**
     * Кнопка "Показать еще". Перемещается на 1 страницу и добавляет к отображаемым элементам еще this.length элементов
     */
    showMore() {
      this.changeLength = false;

      if (this.currentLength === this.length) {
        this.page = 2;
      } else this.page++;

      this.currentLength += this.length;

      this.$emit("params", {
        currentPage: 1,
        length: this.currentLength
      });
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
